import { render, staticRenderFns } from "./edition-list.vue?vue&type=template&id=08756da2&scoped=true&"
import script from "./edition-list.vue?vue&type=script&lang=ts&"
export * from "./edition-list.vue?vue&type=script&lang=ts&"
import style0 from "./edition-list.vue?vue&type=style&index=0&id=08756da2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08756da2",
  null
  
)

export default component.exports